export default __webpack_public_path__ + "static/MandM-cff4c06e124df97eb5384e040ec1e3fd.png";